var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrizesMenuActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77034 13.4531C6.88268 17.9522 10.4903 21.8894 14.9908 21.8894V21.8894V21.8894C19.5619 21.8894 23.0836 18.0157 23.209 13.4463C23.2244 12.8844 23.2325 12.3183 23.2325 11.7482C23.2325 9.05359 23.0685 6.41933 22.7899 3.9247C22.6885 3.01638 22.0046 2.28132 21.1031 2.13067C19.1275 1.80049 17.1001 1.60693 14.9908 1.60693C12.8768 1.60693 10.8127 1.78917 8.84573 2.12551C7.95987 2.27698 7.29018 2.99997 7.18736 3.89279C6.89964 6.39132 6.74902 9.04364 6.74902 11.7482C6.74902 12.3208 6.75626 12.8891 6.77034 13.4531Z",
    fill: "#1D202B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77034 13.4531C6.88268 17.9522 10.4903 21.8894 14.9908 21.8894V21.8894V21.8894C19.5619 21.8894 23.0836 18.0157 23.209 13.4463C23.2244 12.8844 23.2325 12.3183 23.2325 11.7482C23.2325 9.05359 23.0685 6.41933 22.7899 3.9247C22.6885 3.01638 22.0046 2.28132 21.1031 2.13067C19.1275 1.80049 17.1001 1.60693 14.9908 1.60693C12.8768 1.60693 10.8127 1.78917 8.84573 2.12551C7.95987 2.27698 7.29018 2.99997 7.18736 3.89279C6.89964 6.39132 6.74902 9.04364 6.74902 11.7482C6.74902 12.3208 6.75626 12.8891 6.77034 13.4531Z",
    stroke: "#84C70D",
    strokeWidth: 3.21429
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9912 21.9058V28.3929",
    stroke: "#84C70D",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83984 28.3931H20.142",
    stroke: "#84C70D",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7178 3.66748H26.2411C27.4246 3.66748 28.384 4.62687 28.384 5.81034V6.18874C28.384 8.19478 27.7327 10.1187 26.5735 11.5371C25.6589 12.6564 24.4871 13.3886 23.228 13.6478",
    stroke: "#84C70D",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20801 3.66748H3.75709C2.57363 3.66748 1.61424 4.62687 1.61424 5.81034V6.18874C1.61424 8.19478 2.26548 10.1187 3.4247 11.5371C4.33431 12.6502 5.49823 13.3805 6.74934 13.6434",
    stroke: "#84C70D",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizesMenuActive);
export default __webpack_public_path__ + "static/media/prizes-menu-active.945c69dd1d7b143c0fabdb8a503b3589.svg";
export { ForwardRef as ReactComponent };